import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=5f0a40ba&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f0a40ba')) {
      api.createRecord('5f0a40ba', component.options)
    } else {
      api.reload('5f0a40ba', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=5f0a40ba&", function () {
      api.rerender('5f0a40ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wu21Z1sL3wNk/JS/offershelp.vue"
export default component.exports